const getCurrentDateTime = () => {
  const today = new Date().toJSON();
  const date = today.substr(0, today.indexOf('T'));
  const time = today.substr(today.indexOf('T') + 1, 8);

  return `${date} ${time}`;
};

export default getCurrentDateTime;
